import { Ng2StateDeclaration } from '@uirouter/angular';

import { MonitoringFaultComponent } from './containers/monitoring-fault/monitoring-fault.component';
import { MonitoredTrainComponent } from './containers/monitored-train/monitored-train.component';
import { MonitoringOverviewComponent } from './containers/monitoring-overview/monitoring-overview.component';


export const monitoringOverviewState: Ng2StateDeclaration = {
    // parent: 'app', // declares that 'users' is a child of 'app'
    name: 'home',
    url: '/project/:projectId/overview',
    component: MonitoringOverviewComponent,
    params: {
        projectId: {squash: true, value: null}
    }
};

export const monitoringFaultState: Ng2StateDeclaration = {
    // parent: 'app', // declares that 'users' is a child of 'app'
    name: 'monitoring',
    url: '/project/:projectId/monitoring/:tab',
    component: MonitoringFaultComponent,
    params: {
        tab: {squash: true, value: null},
        projectId: {squash: true, value: null}
    }
};

export const monitoringTrainDetailsState: Ng2StateDeclaration = {
    // parent: 'app', // declares that 'users' is a child of 'app'
    name: 'monitoring-detail',
    url: '/project/:projectId/monitoring-detail/train/:trainId/:tab',
    component: MonitoredTrainComponent,
    params: {
        tab: {squash: true, value: null},
        projectId: {squash: true, value: null},
        trainId: {squash: true, value: null}
    }
};

export const MONITORING_STATES = [
    monitoringFaultState,
    monitoringTrainDetailsState,
    monitoringOverviewState
];
